(ns manatee.components.editors.spellcheck
  (:require [ajax.edn :refer [edn-request-format edn-response-format]]
            [clojure.string :as str]
            [kee-frame.core :as kf]
            [manatee.components.editors.app-db :as editors-db]
            [manatee.fx.debounce :as debounce]
            [re-frame.core :as rf]
            [rothko.editor.document.script :as script]))

(defn filter-misspelled-words
  [spelling-disctionary words]
  (filter #(false? (get spelling-disctionary %)) words))

(defn filter-unknown-words
  [spelling-dictionary words]
  (filter #(nil? (get spelling-dictionary %)) words))

(def sentence-ending-punctuation #{"." "?" "!"})

(defn word-ends-sentence?
  [word]
  (when (seq word)
    (let [end (str (last word))]
      (contains? sentence-ending-punctuation end))))

(defn word-capitalised?
  [word]
  (when (seq word)
    (let [start (str (first word))]
      (not= start (str/lower-case start)))))

(defn exclude-capitalised-words-inside-sentences
  [words]
  (->> words
       (reduce
        (fn [[start-of-sentence? acc] word]
          [(word-ends-sentence? word)
           (cond-> acc
             (or (not (word-capitalised? word))
                 start-of-sentence?)
             (conj word))])
        [true []])
       second))

(defn merge-contractions
  [script]
  (loop [[this next & etc] script, res []]
    (if this
      (if (script/detect-contraction this next)
        (recur etc (conj res (update this :word str (:word next))))
        (recur (cons next etc) (conj res this)))
      res)))

(defn script->words
  [script]
  (->> (merge-contractions script)
       (filter #(and (#{:word :edit} (:type %))
                     (not (:edited? %))
                     (not (:tagged? %))))
       (map :word)
       exclude-capitalised-words-inside-sentences))

(rf/reg-event-db
 ::set-misspelled-words
 (fn set-misspelled-words
   [db [_ words]]
   (editors-db/set-misspelled-words db words)))

(rf/reg-event-db
 ::on-spellcheck-success
 (fn spellcheck-success
   [db [_ words]]
   (editors-db/update-spelling-dictionary db words)))

(rf/reg-event-fx
 ::check-words
 (fn check-words
   [_ [_ words]]
   (when (seq words)
     {:http-xhrio {:method :post
                   :uri (kf/path-for [:api/spellcheck])
                   :params {:words words}
                   :format (edn-request-format)
                   :response-format (edn-response-format)
                   :on-success [::on-spellcheck-success]
                   :on-failure []}})))

(rf/reg-event-fx
 ::check-script
 (fn check-script
   [_ [_ script]]
   {:dispatch [::check-words (script->words script)]}))

(rf/reg-event-fx
 ::check-script-debounced
 (fn check-script-debounced
   [{:keys [db]} [_ script]]
   {::debounce/dispatch ["spellcheck"
                         [::check-words
                          (->> script
                               (script->words)
                               (filter-unknown-words (editors-db/spelling-dictionary db)))]
                         1000]}))
